import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AlertContext from '../../context/AlertContext';

import MainStyled from '../../asset/styled/MainStyled';
import TaxNotification from './TaxNotification';
import MenuCollection from './MenuCollection';
import AiBanner from './AiBanner';
import PersonalNotification from './PersonalNotification';
import { resetResultQueryState } from '../resultQuery/resultQuerySlice';
import { getCheckMsg, getResultDataView, getYAPlan } from '../common/commonSlice';
import { isDateInRange } from '../../common/Util';
import FloatingCallConsult from './FloatingCallConsult';
import InputPeriodEndAlert from './InputPeriodEndAlert';
import ReviewInProgressAlert from './ReviewInProgressAlert';
import ServiceDisruptionAlert from './ServiceDisruptionAlert';
import { getResultQueryDescription, getResultQueryTitle } from '../resultQuery/util';
import CollapsibleBanner from '../../components/CollapsibleBanner';

const Main = () => {
  const { t: tResultQuery } = useTranslation('resultQuery');
  const dispatch = useDispatch();
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  // const { resultData } = useSelector(state => state.result);
  const { myInfo } = useSelector(state => state.myInfo);
  const { yaStart, isMagam, isCertify, callcenter, magamFlag, resultDataView, msgData, yaPlan } =
    useSelector(state => state.common);
  const [isOpen, setIsOpen] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showServiceDisruption, setShowServiceDisruption] = useState(true);

  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const isTargetDate = month === 1 && (day === 15 || day === 16);

  useEffect(() => {
    //내정보 열릴때마다 타는 거 아는데 일단.. 나중에 수정
    if (myInfo && yaStart) {
      //결과상세
      dispatch(getResultDataView());
      //메세지
      dispatch(getCheckMsg());
      //연말정산 스케줄
      dispatch(getYAPlan());
    }
  }, [myInfo, yaStart]);

  useEffect(() => {
    return () => {
      dispatch(resetResultQueryState());
    };
  }, []);

  // useEffect(() => {
  //   if (magamFlag == 'L') setIsOpen(true);
  // }, [magamFlag]);

  useEffect(() => {
    if (
      magamFlag === 'L'
      // && yaPlan && isDateInRange(yaPlan.htmC1SD, yaPlan.htmC1ED)
    ) {
      setShowReviewModal(true);
    }
  }, [magamFlag, yaPlan]);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <MainStyled>
      {/* 연말정산 시작 및 결과 */}
      <TaxNotification />
      {/* 개인알림 */}
      {(isMagam || isCertify) && (
        <CollapsibleBanner
          title={getResultQueryTitle(resultDataView, tResultQuery)}
          description={getResultQueryDescription(resultDataView, tResultQuery, msgData, isCertify)}
        />
      )}
      {/* 메뉴모음집 */}
      <MenuCollection />
      {/* ai */}
      {/* <AiBanner /> */}
      {/* 전화 상담 */}
      {callcenter && <FloatingCallConsult />}

      {/* <InputPeriodEndAlert isOpen={isOpen} onClose={handleClose} isTargetDate={isTargetDate} /> */}
      <ReviewInProgressAlert isOpen={showReviewModal} onClose={() => setShowReviewModal(false)} />
      {/* {showServiceDisruption && (
        <ServiceDisruptionAlert onClose={() => setShowServiceDisruption(false)} />
      )} */}
    </MainStyled>
  );
};

export default Main;
